import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputDateUI from '../../../widgets/form/InputDateUI'

const LoanStructureUpdateModalUI = ({
  context,
  loan,
  successMsg,
  errorList,
  setErrorList,
  // modes
  updateMode,
  submitted,
  // event handlers
  onSubmit,
  onCancelClick,
  // fields 
  pledgeOrNdu,
  onPledgeOrNduChange,
  pledgeOrNduError,
  setPledgeOrNduError,
  pledgeOrNduList,
  escrow,
  onEscrowChange,
  escrowError,
  setEscrowError,
  escrowTypeList,
  specialTerms,
  onSpecialTermsChange,
  specialTermsError,
  setSpecialTermsError,
  booleanList,
  // date fields
  boardMeetingDate,
  onBoardMeetingDateChange,
  boardMeetingDateError,
  setBoardMeetingDateError,
  shareholderMeetingDate,
  onShareholderMeetingDateChange,
  shareholderMeetingDateError,
  setShareholderMeetingDateError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update loan structure'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='pledgeOrNdu' label='Pledge/NDU'
      value={pledgeOrNdu} onChange={onPledgeOrNduChange} optionList={pledgeOrNduList}
      error={pledgeOrNduError} setError={setPledgeOrNduError}
    />
    <InputSelectSF type='select' name='escrow' label='Escrow'
      value={escrow} onChange={onEscrowChange} optionList={escrowTypeList}
      error={escrowError} setError={setEscrowError}
    />
    <InputSelectSF type='select' name='specialTerms' label='Special terms'
      value={specialTerms} onChange={onSpecialTermsChange} optionList={booleanList}
      error={specialTermsError} setError={setSpecialTermsError}
    />
    <InputDateUI context={context} name='boardMeetingDate' label='Board meeting date'
      selectedDateISO={boardMeetingDate} onChange={onBoardMeetingDateChange}
      error={boardMeetingDateError} setError={setBoardMeetingDateError}
    />
    <InputDateUI context={context} name='shareholderMeetingDate' label='Shareholder meeting date'
      selectedDateISO={shareholderMeetingDate} onChange={onShareholderMeetingDateChange}
      error={shareholderMeetingDateError} setError={setShareholderMeetingDateError}
    />
  </ModalFormUI>

export default LoanStructureUpdateModalUI
